"use client";
import type { ReactElement } from "react";
import { SCROLL_FADE_COLOR, SCROLL_FADE_WIDTH_PX, } from "./gantt-constants";
export enum GanttScrollFadeSide {
    Left = "left",
    Right = "right"
}
const SCROLL_FADE_BACKGROUND_BY_SIDE: Record<GanttScrollFadeSide, string> = {
    [GanttScrollFadeSide.Left]: `linear-gradient(to right, ${SCROLL_FADE_COLOR}, transparent)`,
    [GanttScrollFadeSide.Right]: `linear-gradient(to left, ${SCROLL_FADE_COLOR}, transparent)`,
};
const SCROLL_FADE_LEFT_BY_SIDE: Record<GanttScrollFadeSide, string | number> = {
    [GanttScrollFadeSide.Left]: 0,
    [GanttScrollFadeSide.Right]: `calc(100% - ${SCROLL_FADE_WIDTH_PX}px)`,
};
export interface GanttScrollFadeProps {
    side: GanttScrollFadeSide;
}
export function GanttScrollFade({ side, }: GanttScrollFadeProps): ReactElement {
    return (
      <div data-el="Cmarkdowngantt/ScrollFade/Root" style={{
            position: "sticky",
            left: SCROLL_FADE_LEFT_BY_SIDE[side],
            top: 0,
            bottom: 0,
            width: SCROLL_FADE_WIDTH_PX,
            pointerEvents: "none",
            backgroundImage: SCROLL_FADE_BACKGROUND_BY_SIDE[side],
            zIndex: 10,
        }}/>
    );
}
